module.exports = __webpack_public_path__ + "img/mercadolivre.aae34d4b.svg";